<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        :todo-list.sync="todoList"
        show-to-do
        @reloadData="requestData()"
        @preDeal="preDealFun"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.nickname"
              placeholder="人员昵称"
              clearable
              @keyup.enter.native="searchData"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.storeName"
              placeholder="门店名称"
              clearable
              @keyup.enter.native="searchData"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.certificateNo"
              placeholder="专卖证号"
              clearable
              @keyup.enter.native="searchData"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.grantResult"
              clearable
              placeholder="成长值发放结果"
              style="width: 100%;"
            >
              <el-option
                v-for="(data, index) in grantResultData"
                :key="index"
                :label="data.label"
                :value="data.value"
              />
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px; padding: 0 2px;"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @grant="grantFun(arguments)"
        @revoke="revokeFun(arguments)"
        @view="handleView(arguments)"
        @dblclick="handleView(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :dialog-visible.sync="dialogViewVisible"
      @reloadData="loadTableData()"
    />
    <!-- 待处理的异常清单 -->
    <task-list-dialog
      :dialog-title="'待处理的问卷异常清单'"
      :dialog-visible.sync="dialogTaskVisible"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 待处理的异常明细清单
import taskListDialog from './components/taskListDialog'
// 查看
import viewDialog from './components/viewDialog'
// 调研问卷参与人员API
import { loadSurveyQuestionnaireDetailListDataApi, exportSurveyQuestionnaireDetailListDataApi, grantSurveyQuestionnaireDetailApi, revokeSurveyQuestionnaireDetailApi } from "@/api/v2/surveyQuestionnaireDetail";
import { countTodoSurveyQuestionnaireDetailExceptionApi } from "@/api/v2/surveyQuestionnaireDetailException";

export default {
  name: 'SurveyQuestionnaireDetailView',
  components: { CustomTable2, TableOperation2, viewDialog, taskListDialog },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'survey_questionnaire_detail_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['qq_questionnaire_detail_view'],
            prop: 'grant',
            label: '发放成长值',
            method: 'grant'
          },
          {
            permissionSigns: ['qq_questionnaire_detail_view'],
            prop: 'revoke',
            label: '撤销发放成长值',
            method: 'revoke'
          },
          {
            permissionSigns: ['qq_questionnaire_detail_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['qq_questionnaire_detail_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          nickname: '',
          storeName: '',
          certificateNo: '',
          grantResult: '',
        },
      },
      // 待办
      todoList: [
        {
          permissionSigns: ['qq_questionnaire_detail_exception_deal'],
          label: '待处理的异常信息',
          method: 'preDeal',
          count: 0
        }
      ],
      grantResultData: [{ value: 1, label: "已发放" }, { value: 2, label: "未发放" }],
      id: null,
      dialogViewVisible: false,
      dialogTaskVisible: false
    }
  },
  created () {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80, align: 'center' },
      { prop: 'provinceName', label: '省区', filterColumn: 'tsq.province_name', width: 100 },
      { prop: 'questionnaireCode', label: '问卷编号', filterColumn: 'tsq.code', width: 110 },
      { prop: 'questionnaireName', label: '问卷名称', filterColumn: 'tsq.name', width: 200 },
      { prop: 'activityDate', label: '活动日期', filterColumn: 'tsq.activity_date', width: 110 },
      { prop: 'nickname', label: '昵称', filterColumn: 'tsqd.nickname', width: 150 },
      { prop: 'market', label: '市场', filterColumn: 'tsqd.market', width: 150 },
      { prop: 'storeName', label: '门店名称', filterColumn: 'tsqd.store_name', width: 200 },
      { prop: 'certificateNo', label: '专卖证号', filterColumn: 'tsqd.certificate_no', width: 120 },
      { prop: 'bxPhone', label: '本香门店码绑定电话', filterColumn: 'tsqd.bx_phone', width: 165 },
      { prop: 'level', label: '门店档位', filterColumn: 'tsqd.level', width: 110 },
      { prop: 'finishAnswerTime', label: '答题结束时间', filterColumn: 'tsqd.finish_answer_time', width: 150 },
      { prop: 'growthValue', label: '成长值', filterColumn: 'tsq.growth_value', width: 110 },
      { prop: 'grantGrowthValueTime', label: '成长值发放时间', filterColumn: 'tsq.grant_growth_value_time', width: 150 },
      { prop: 'statusValue', label: '状态', filterColumn: "(case tsqd.status when 1 then '有效' when 2 then '无效' else '' end)", width: 150 },
      { prop: 'exceptionTypesValue', label: '异常信息', filterColumn: "tsqd.exception_types_value", width: 200 },
      { prop: 'grantResultValue', label: '成长值发放结果', filterColumn: "(case tsqd.grant_result when 1 then '已发放' when 2 then '未发放' else '' end)", width: 150 },
      { prop: 'noGrantReason', label: '成长值未发放原因', filterColumn: 'tsqd.no_grant_reason', width: 300 },
      { prop: 'uid', label: '问卷用户ID', filterColumn: "tsqd.uid", width: 200 },
      { prop: 'wxId', label: '微信号', filterColumn: "ifnull(twcc.user_name, '')", width: 150 },
      { prop: 'wxNickname', label: '微信昵称', filterColumn: "ifnull(twcc.nickname, '')", width: 150 },
      { prop: 'appUserId', label: '小程序用户编号', filterColumn: "tsqd.app_user_id", width: 150 },
      { prop: 'appStoreName', label: '小程序门店名称', filterColumn: "IFNULL(tau.store_name, '')", width: 150 },
      { prop: 'appCertificateNo', label: '小程序专卖证号', filterColumn: "IFNULL(tau.certificate_no, '')", width: 150 },
      { prop: 'appPhone', label: '小程序手机号', filterColumn: "IFNULL(tau.phone, '')", width: 130 },
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadSurveyQuestionnaireDetailListDataApi(_this.masterList.tableQuery).then(response => {
        const { data } = response;
        _this.handleData(data.list || [])
        _this.masterList.tableDataTotal = data.total || 0
      }).catch()
      this.getTodoCount()
    },
    // 获取待办任务数量
    getTodoCount () {
      let params = { processResult: 1 }
      countTodoSurveyQuestionnaireDetailExceptionApi(params).then(res => {
        this.todoList[0].count = res.data ? res.data : 0
      })
    },
    // 查看
    handleView (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的腾讯问卷参与人员', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.dialogViewVisible = !_this.dialogViewVisible
    },
    // 待处理清单
    preDealFun(){
      this.dialogTaskVisible = !this.dialogTaskVisible
    },
    // 发放成长值
    grantFun(args){
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择数据行', type: 'warning' })
        return
      }
      _this.$confirm('是否确认发放该腾讯问卷参与人员的成长值？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        grantSurveyQuestionnaireDetailApi({ id: args[0].id }).then(() => {
          _this.$message({ message: '发放成长值成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 撤销发放成长值
    revokeFun(args){
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择数据行', type: 'warning' })
        return
      }
      _this.$confirm('是否确认撤销发放该腾讯问卷参与人员的成长值？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        revokeSurveyQuestionnaireDetailApi({ id: args[0].id }).then(() => {
          _this.$message({ message: '发放成长值成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 导出数据API
    exportByPage () {
      let _this = this;
      exportSurveyQuestionnaireDetailListDataApi(_this.exportObj).then((response) => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
